var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-project"},[(_vm.ad.imageUrl)?_c('a',{attrs:{"href":_vm.ad.turnUrl || 'javascript:void(0)',"target":_vm.ad.turnUrl ? '_blank' : '_self'}},[_c('img',{attrs:{"src":_vm.ad.imageUrl}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }